import axios from 'axios';
import React, { useState, useRef, useEffect }  from 'react';
import RadarGraph from '../components/charts/RadarGraph';
import KnobSet from '../components/KnobSet';
import { Checkbox, FormControlLabel, FormGroup
    // , FormControl, FormLabel, Radio, RadioGroup
} from '@mui/material';
import Selector from '../components/Selector';
import Switch from '@mui/material/Switch';

import ProximityTable from '../components/ProximityTable';
import Modal from '../components/Modal';

import { dimensionNames, dimPctNames, attributeNames, 
         getDimValueRaw
        //  , getDimValueNorm
         } from '../utils/variables';
import KnobSetDim from '../components/KnobSetDim';
import KnobTypeRadio from '../components/KnobTypeRadio';
// import SliderCirc from '../components/SliderCirc';
// import SliderVert from '../components/SliderVert';


import { alpha, styled } from '@mui/material/styles';
import { pink } from '@mui/material/colors';


import { AiOutlineRight } from "react-icons/ai";

// import SyncLoader from "react-spinners/SyncLoader";
import Loading from '../components/Loading';



function Simulator(props) {

    // Show simulator
    const [simOpen, setSimOpen] = useState(false);


    // Initialize attribute values
    const attValueInit = {};
    for (var i=0; i<36; i++) {
        attValueInit[attributeNames[i]] = 0
    };
    const [attValue, setAttValue] = useState(attValueInit);
    const dimValueRaw = getDimValueRaw(attValue);
    // const dimValueNorm = getDimValueNorm(dimValueRaw);


    // Prepare data for radar chart
    const dimPctInit = Object.fromEntries(
        dimensionNames.map((dimension) => [dimension + '_pct', 0])
    );

    // Found proximity
    const returnProximityInit = [
        Object.assign({}, 
        {'rank': 0,
         'show_name': '',}, dimPctInit)
    ];
    const [returnProximity, setReturnProximity] = useState(returnProximityInit);

    // Selected reference
    const returnReferenceInit = [
        Object.assign({}, 
        {'show_name': '',}, dimPctInit)
    ];
    const [returnReference, setReturnReference] = useState(returnReferenceInit);

    // Calculate dimension pct based on attribute inputs
    
    
    const returnDataInit = Object.fromEntries(
        dimensionNames.map((dimension) => [dimension + '_pct_get', 0])
    );
    const [returnData, setReturnData] = useState(returnDataInit);

    
    const handleSliderChangeConvert = (e) => {

        // Reset proximity data
        setProxClicked(false);

        const { name, value } = e.target;
        // console.log(name)
        setAttValue(prevState => ({
            ...prevState,
            [name]: value,
        }));

        // const url = 'http://127.0.0.1:8000/data/percentile/'
        const url = process.env.REACT_APP_BACKEND_URL + '/data/percentile/';

        const bodyData = JSON.stringify(
            dimValueRaw
        );

        const reqOpt = {method:"POST", headers:{"Content-type":"application/json"}, body:bodyData};
        fetch(url, reqOpt)
            .then((resp) => resp.json())
            .then((respJ) => setReturnData(JSON.parse(respJ.result)[0]))
    }

    // Update (custom) dimension pct based on dimension inputs
    const handleSliderChangeDim = (e) => {
        const { value, name } = e.target;

        // Update dim_pct_get
        const dimGet = name.toLowerCase() + "_pct_get";
        setReturnData(prevState => ({
            ...prevState,
            [dimGet]: value,
        }));

        // Reset attValue
        // setAttValue(attValueInit);
    }



    // Handle checkboxes for proximity content type
    const [checkShow, setCheckShow] = useState(true);
    const [checkMovie, setCheckMovie] = useState(false);
    const [checkNetwork, setCheckNetwork] = useState(false);

    const checkContent = [checkShow, checkMovie, checkNetwork];

    const handleCheckbox = (event) => {
        if (event.target.name==="show") {
            setCheckShow(event.target.checked);
        } else if (event.target.name==="movie") {
            setCheckMovie(event.target.checked)
        } else {
            setCheckNetwork(event.target.checked)
        }
    }

    // Submit button (find proximity shows)
    const [proxClicked, setProxClicked] = useState(false);



    const handleSubmit = (event) => {

        event.preventDefault();

        // Set loading true
        setFindLoading(true);

        // Reset
        setProxClicked(false);
        setProxClicked(true);
        setProximityDisplay(0);

        var dataSend;
        if (knobType==='attribute') {
            dataSend = dimValueRaw;
        } else {
            dataSend = returnData;
        }
        dataSend['knob_type'] = knobType;
        dataSend['content_type'] = checkContent;
        dataSend['include_anime'] = 0;
        dataSend['include_low'] = 1;
        dataSend['selected_ids'] = [];

        // const url = 'http://127.0.0.1:8000/data/proximity/'
        const url = process.env.REACT_APP_BACKEND_URL + '/data/proximity/';
        const bodyData = JSON.stringify(
            // dimValueRaw
            dataSend
        );

        const reqOpt = {method:"POST", headers:{"Content-type":"application/json"}, body:bodyData};
        fetch(url, reqOpt)
          .then((resp) => resp.json())
          .then((respJ) => {setReturnProximity(JSON.parse(respJ.result));
                            setFindLoading(false);})
    }


    const [switched, setSwitched] = useState(false);
    const handleSwitch = (event) => {
        setSwitched(event.target.checked);
    };



    // Grab last database data stored in backend
    const [dbData, setDbData] = useState([{},]);
    // console.log(dbData)
    const dbContentList = [];
    dbData.map((record,index)=>(
        dbContentList.push({
            value: index,
            label: record.show_name,
            type: record.content_type,
        })
    ))

    // Loading content data when page starts
    useEffect(() => {
        const runCall = async () => {
            let apiValue = await fetchData();
            // console.log('apiValue is', JSON.parse(apiValue))
            // setDbData(apiValue);
            setDbData(JSON.parse(apiValue.db_most_recent))
            return null;
        }

        const fetchData = async () => {
        //   const apiUrl = process.env.REACT_APP_BACKEND_URL + '/media/db_most_recent_send.json';
          const apiUrl = process.env.REACT_APP_BACKEND_URL + '/media/db_save.json';
          try {
            const response = (await axios.get(apiUrl)).data;
            return response;
          } catch (err) {
            console.log(err);
            return null;
          }
        }
        runCall();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Loading dim pct (for att values all zero) when page starts
    useEffect(() => {
        const runCall = async () => {
            await fetchData();
        //     console.log('apiValue is', apiValue)
        //     console.log('apiValue is', JSON.parse(apiValue))
        //     setDbData(JSON.parse(apiValue));
            return null;
        }

        const fetchData = async () => {
            const url = process.env.REACT_APP_BACKEND_URL + '/data/percentile/';

            const bodyData = JSON.stringify(
                dimValueRaw
            );
          try {
            const reqOpt = {method:"POST", headers:{"Content-type":"application/json"}, body:bodyData};
            fetch(url, reqOpt)
                .then((resp) => resp.json())
                .then((respJ) => setReturnData(JSON.parse(respJ.result)[0]))
          } catch (err) {
            console.log(err);
            return null;
          }
        }
        runCall();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Use reference button
    const [refClicked, setRefClicked] = useState(false);
    const handleSubmitRef = (event) => {
        event.preventDefault();
        setRefClicked(true);

        // const url = 'http://127.0.0.1:8000/data/read/'
        // const url = process.env.REACT_APP_BACKEND_URL + '/data/read/';
        // const reqOpt = {method:"GET"};
        // fetch(url, reqOpt)
        //   .then((resp) => (resp.json()))
        //   .then((respJ) => setDbData(JSON.parse(respJ.result)),
        //                     )
    }

    console.log(handleSubmitRef);
    
    // Select reference
    const [selectedOption, setSelectedOption] = useState('Euphoria');
    const handleSelectorChange = (selectedOption) => {

        // Collapse top navbar
        // props.handleClose();
        // window.open('http://127.0.0.1:3000/simulator','_blank')
        bottomRef.current?.scrollIntoView({behavior: 'smooth'});

        // Reset knob type to default
        setKnobType("dimension");

        // Show knobs and radar chart
        setSimOpen(true);
        setKnobTypeOpen(true);

        // Reset proximity button click & proximity data
        setProxClicked(false);
        setProximityDisplay(0);

        // Reset proximity data
        setReturnProximity(returnProximityInit);

        // Show reference radar chart (toggle switch on)
        setSwitched(true);

        // Update selected reference
        setSelectedOption(selectedOption);

        // Fetch db data
        const selectedData = dbData[selectedOption.value];

        // Update attribute values
        const selectedAtt = Object.keys(selectedData)
            .filter((key) => attributeNames.includes(key))
            .reduce((obj, key) => {
                return Object.assign(obj, {
                [key]: selectedData[key]
                });
        }, {});

        setAttValue(prevState => ({
            ...prevState,
            ...selectedAtt,
        }));


        // Update dimension pct values (for reference radar chart)
        const selectedDimPct = Object.keys(selectedData)
            .filter((key) => dimPctNames.includes(key))
            .reduce((obj, key) => {
                return Object.assign(obj, {
                [key]: selectedData[key]
                });
        }, {});
        setReturnReference(prevState => ({
            ...prevState,
            ...selectedDimPct,
        }));

        // Update dimension pct values (for custom radar chart)
        const selectedDimPctGet = Object.keys(selectedData)
            .filter((key) => dimPctNames.includes(key))
            .reduce((obj, key) => {
                return Object.assign(obj, {
                [key+'_get']: selectedData[key]
                });
        }, {});
        setReturnData(prevState => ({
            ...prevState,
            ...selectedDimPctGet,
        }));

    }


    // Data for radar chart plotting
    const radarChartData = [];
    const [proximityDisplay, setProximityDisplay] = useState(0);
    dimensionNames.map((dimension, index)=>(
        radarChartData.push({
            subject: dimension.charAt(0).toUpperCase()+dimension.slice(1),
            Custom: returnData[dimension+'_pct_get'],
            Closest: returnProximity[proximityDisplay][dimension+'_pct'],
            Reference: returnReference[dimension+'_pct'],
            fullMark: 100,
        })
    ));

    // Click other proximity shows
    const handleShowBtn = (event) => {
        event.preventDefault();

        const clickedId = event.target.id;
        // Update proximity data (dim pct for proximity radar chart)
        if (clickedId!=='') {
            setProximityDisplay(clickedId);
        } else {
            setProximityDisplay(proximityDisplay);
        }        
    };


    // Handle modal to show list of proximity data
    const [openModal, setOpenModal] = useState(false);


    // Handle More > to full table of proximity data
    const tableRef = useRef(null);
    const bottomRef = useRef(null);



    // Choose Attribute OR Dimension knob set
    // const [knobType, setKnobType] = useState('dimension');
    const [knobType, setKnobType] = useState('dimension');

    const handleRadioChange = (event) => {
        setKnobType(event.target.value);

        // Change radar chart (returnDataPct) when switch back to knobType = attribute
        // Reset proximity data
        setProxClicked(false);
        
        // console.log(name)
        // setAttValue(prevState => ({
        //     ...prevState,
        // }));

        // const url = 'http://127.0.0.1:8000/data/percentile/'
        const url = process.env.REACT_APP_BACKEND_URL + '/data/percentile/';

        const bodyData = JSON.stringify(
            dimValueRaw
        );

        const reqOpt = {method:"POST", headers:{"Content-type":"application/json"}, body:bodyData};
        fetch(url, reqOpt)
            .then((resp) => resp.json())
            .then((respJ) => setReturnData(JSON.parse(respJ.result)[0]))
    };

    const [knobTypeOpen, setKnobTypeOpen] = useState(false);


    
    const GreenSwitch = styled(Switch)(({ theme }) => ({
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: pink[600],
          '&:hover': {
            backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
          },
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: pink[600],
        },
      }));

    const [findLoading, setFindLoading] = useState(false);


    


    


    return (
        <div className=''>
            <div className='h-0 sticky top-40 z-10'>
                {/* {props.isExpand &&
                <div className='bg-[#3d3935] h-20 sticky top-0 z-40 shadow-xl'>
                </div>
                } */}
                
                <div className={`sticky top-20 flex -space-x-4 ${knobTypeOpen ? 'w-40' : 'w-6 ml-1.5'} duration-300`}>
                    <div>
                    <KnobTypeRadio open={knobTypeOpen}
                                   value={knobType}
                                   onChange={handleRadioChange}/>
                    </div>
                    <AiOutlineRight className={`bg-[#3d3935] h-32 w-6 px-1 shadow-xl 
                                                text-white hover:cursor-pointer
                                               ${knobTypeOpen && 'rotate-180'}`}
                                    onClick={()=>{setKnobTypeOpen(!knobTypeOpen)}}/>
                </div>
            </div>

            {findLoading && 
            <Loading loading={findLoading}/>
            }


            <div className='flex justify-center items-baseline mb-10 mt-24'>
                <p className='text-4xl md:text-5xl font-[Philosopher]'>emotional</p>
                <p className='text-5xl md:text-6xl font-extrabold font-[Philosopher]'>Simulator</p>
            </div>

            <div className='flex-inline justify-items-center z-50'
                 onClick={() => {setOpenModal(false);setKnobTypeOpen(false)}}>
                <div className={`${simOpen && '-mt-2'}`}>
                    <Selector options={dbContentList}
                              selectedOption={selectedOption}
                              handleChange={handleSelectorChange}
                              width='w-80'/>
                </div>
                {!simOpen && 
                <div className='flex justify-center items-top mt-4'>
                    {/* <TbArrowUpCircle className='text-4xl -mt-1 animate-bounce'/> */}
                    <p className='text-md md:text-lg font-semibold animate-pulse
                                  ml-4 md:ml-0'>Select a show | movie | network to start with!</p>
                </div>
                }
            </div>


        <div className={`${simOpen ? 'scale-100 origin-top' 
                        : '-translate-y-[0rem] scale-y-0 opacity-100 origin-top h-screen'} duration-1000`}>
        <div className='flex-inline -z-50'
             onClick={() => {setOpenModal(false);setKnobTypeOpen(false)}}>
            <div className='knob-set-header flex'>
                <div>
                    <div className='ml-0 xl:ml-24 mt-4 md:-mt-8'>
                        <p className='text-2xl font-bold text-left ml-20'>{knobType==='attribute' ? 'Attributes' : 'Dimensions'}</p>
                        <p className='text-md text-left ml-20'>
                            {knobType==='attribute' ? 'Customize raw attribute values'
                                                    : 'Customize dimension percentiles'}</p>
                    </div>
                </div>
            </div>

            
            
            
            <div className='md:flex-inline lg:flex justify-center'>
                {knobType==='attribute' ?
                <div className={`ml-12 mr-12 lg:mr-0 mt-4 pl-2 pr-8 py-2 h-fit bg-gray-100 bg-opacity-40 rounded-xl shadow-md
                                ${openModal && 'opacity-20'}`}>
                    <KnobSet attributes={attValue}
                            sliderChange={handleSliderChangeConvert}/>
                </div>
                :
                <div className={`ml-16 mr-7 mt-4 px-2 pt-4 pb-8 h-fit bg-gray-100 bg-opacity-40 rounded-xl shadow-md
                                ${openModal && 'opacity-20'}`}>
                    <div className='flex justify-center -ml-12'>
                    <KnobSetDim dimensionsPct={returnData}
                                sliderChange={handleSliderChangeDim}/>
                    </div>
                    <p className='mt-3 text-sm px-2'>Note: Tuning dimension percentiles does not update raw attribute values!</p>
                </div>
                }

                <div className='flex-inline mt-20 lg:mt-0 lg:ml-0'>
                    <div className='flex -mt-16 mr-4 md:mr-12 lg:mr-8 xl:ml-48 items-start justify-end' 
                         onClick={(e)=>(e.stopPropagation())}>
                        {/* Submit */}
                        <button type="submit"
                                onClick={handleSubmit}
                                className="inline-flex justify-center p-2 md:p-2 md:px-6 rounded-md shadow-sm mb-12
                                        bg-pink-600 text-sm md:text-base font-medium text-white
                                        hover:bg-pink-700 focus:outline-none focus:ring-offset-2"
                        >
                            Find Proximity
                        </button>
                        <div className='flex items-center'>
                            <Checkbox name="show"
                                    defaultChecked
                                    onClick={handleCheckbox}
                                    size="small" />
                            <p className='-ml-2'>Show</p>

                            <Checkbox name="movie"
                                    onClick={handleCheckbox}
                                    size="small" />
                            <p className='-ml-2'>Movie</p>

                            <Checkbox name="network"
                                    onClick={handleCheckbox}
                                    size="small" />
                            <p className='-ml-2'>Network</p>
                        </div>
                    </div>
                    
                    

                    

                    {proxClicked &&
                    <div className='relative' onClick={(e)=>{e.stopPropagation()}}>
                        {!openModal & returnProximity[0].show_name!=='' ?
                        <button className='absolute ml-2 left-28 top-12 z-0
                                           bg-gray-400 text-white text-xs font-semibold px-4 py-1 rounded-lg
                                           hover:bg-gray-300'
                                onClick={() => setOpenModal(true)}>
                            MORE
                        </button> : null
                        }
                    </div>
                    }
                    <div onClick={(e)=>{e.stopPropagation()}}>
                        <Modal open={openModal}
                               onClose={() => setOpenModal(false)}
                               onClick={()=>tableRef.current?.scrollIntoView({behavior: 'smooth'})}
                               data={returnProximity}
                               handleShowBtn={handleShowBtn}/>
                    </div>

                    <div className='-mt-0.5 w-full z-0 -mb-8'>
                        { (refClicked || simOpen) & selectedOption!=='hi' ?
                            <div className='relative'>
                                <div className='flex absolute ml-3 left-44 -top-0 z-10 items-center'>
                                    <FormGroup>
                                        {/* <FormControlLabel control={<GreenSwitch defaultChecked />}
                                                        label="Show Reference"
                                                        color="warning" /> */}
                                        <FormControlLabel control={<GreenSwitch checked={switched}
                                                                                size="small"
                                                                        //    color="secondary"
                                                                        onChange={handleSwitch} />}
                                                        label="" />

                                    </FormGroup>
                                    <p className='-ml-5 -mt-0.5 font-semibold'>{!switched && 'Show Reference'}</p>
                                </div>
                            </div>
                            : null
                        }
                        <RadarGraph data={radarChartData}
                                    showName={returnProximity[proximityDisplay].show_name}
                                    refShowName={selectedOption.label}
                                    refShow={switched}
                                    returnProximity={returnProximity} />
                    </div>
                </div>
            </div>


            {/* <div className='-mt-96'
                 ref={bottomRef} /> */}

            

            <div ref={tableRef} />
            <div className='mt-16 lg:px-40'>
                {proxClicked &&
                    <ProximityTable data={returnProximity}
                                    handleShowBtn={handleShowBtn}/>
                }
            </div>
        </div>
        </div>

        <div className={`pt-12 pb-4 pl-4 text-left text-sm items-center flex ${!simOpen && '-mt-96'}`}>
            <p className='italic font-semibold ml-4'>* Low Reach: Incidence Rate less than 1.5</p>
        </div>


        </div>
     );
}

export default Simulator;
